import apiClient from './apiConfig';

export const paynimoService = {
  // Create Paynimo payment session
  createSession: async (sessionData) => {
    try {
      const response = await apiClient.post('/paynimo/session', sessionData);
      return response.data;
    } catch (error) {
      console.error('Create Paynimo session failed:', error);
      throw new Error(error.response?.data?.message || 'Failed to create payment session');
    }
  },

  // Handle Paynimo payment response
  handleResponse: async (responseData) => {
    try {
      const response = await apiClient.post('/paynimo/response', responseData);
      return response.data;
    } catch (error) {
      console.error('Handle Paynimo response failed:', error);
      throw new Error(error.response?.data?.message || 'Failed to process payment response');
    }
  },

  // Get payment status by transaction ID
  getPaymentStatus: async (txnId) => {
    try {
      const response = await apiClient.get(`/paynimo/status/${txnId}`);
      return response.data;
    } catch (error) {
      console.error('Get Paynimo payment status failed:', error);
      throw new Error(error.response?.data?.message || 'Failed to get payment status');
    }
  }
};
